import {createBridgeCaller} from '../BridgeApi';
import {LauncherBridge} from '../launcherBridge';
import {createClassLogger, Logger} from '../../utils/Logging';

const BRIDGE_NAME = 'launcher';
const logger: Logger = createClassLogger('LauncherBridge:Launcher');
const executeLauncherBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const launcherLauncher: LauncherBridge = {
    getAccessToken: (): Promise<string> => executeLauncherBridgeCall('getaccesstoken'),
    requestSignIn: (redirectUrl: string): Promise<void> =>
        executeLauncherBridgeCall('requestsignin', [redirectUrl]),
    isSSOEnabled: (): Promise<boolean> => executeLauncherBridgeCall('isssoenabled'),
    setSSOEnabled: (value: boolean): Promise<void> =>
        executeLauncherBridgeCall('setssoenabled', [value])
};

export default launcherLauncher;
